import clsx from "clsx";
import styles from "./task-category-label.module.css";

const LABELS = {
  meeting: "Meeting",
  "internal-discussions": "Internal Discussions",
  development: "Development",
  "r-and-d": "R&D",
  "pre-sales-analysis": "Pre Sales Analysis",
  architecting: "Architecting",
  design: "Design",
  mentoring: "Mentoring",
  documentations: "Documentations",
} as const;

export type TaskCategoryLabelVariant = keyof typeof LABELS;

export interface TaskCategoryLabelProps {
  variant: TaskCategoryLabelVariant | string;
  label?: string;
  className?: string;
}

export function TaskCategoryLabel({
  variant,
  label,
  className,
}: TaskCategoryLabelProps) {
  const formatLabel = (val: string) => {
    if (!val) return "";
    const lower = val.toLowerCase().trim();
    if (lower === "r & d" || lower === "r&d" || lower === "r - and - d" || lower === "r-and-d") return "R & D";
    return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
  };

  const normalizedVariant = variant as TaskCategoryLabelVariant;
  const displayText = label || LABELS[normalizedVariant] || formatLabel(variant);

  return <p className={clsx(styles.categoryLabel, className)}>{displayText}</p>;
}
